import { useContext } from "react";
import { AuthContext } from "../contexts";
import { supabase } from "../supabase";
import { Btn } from "../components/ui";

const PendingApprovalView = ({ setView }) => {
  const { setUser } = useContext(AuthContext);
  return (
    <div style={{ maxWidth: 480, margin: "80px auto", padding: "0 24px", textAlign: "center" }} className="fade-up">
      <div style={{ fontSize: "48px", marginBottom: 16 }}>⏳</div>
      <h2 style={{ fontSize: "30px", marginBottom: 10 }}>Account pending approval</h2>
      <p style={{ color: "var(--text-dim)", fontSize: "15px", lineHeight: 1.7, marginBottom: 28 }}>
        Your account request has been received. A store admin will review it shortly — we typically respond within one business day.
        You'll be able to sign in once your account is approved.
      </p>
      <Btn variant="ghost" onClick={() => { supabase.auth.signOut(); setUser(null); setView("landing"); }}>Back to Home</Btn>
    </div>
  );
};

export default PendingApprovalView;
